/* eslint-disable max-len */
import React, {
    useState,
    useEffect,
    useContext,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    IconButton
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
// import { UploadComponent } from 'gw-capability-document-react';
import { useAuthentication, withAuthenticationContext } from 'gw-digital-auth-react';
import messages from './AddPaymentPopup.messages';
import metadata from './AddPaymentPopup.metadata.json5';
// eslint-disable-next-line no-unused-vars
import styles from './AddPaymentPopup.module.scss';
import generateGuid from 'uuid/v4';
import UploadComponentForBank from '../../sasria-capability-fnol-common-react/UploadComponentForBank/UploadComponentForBank';

function AddPaymentPopup(props) {
    const [paymentVM, setPaymentVM] = useState({});
    const [showVatExempt, setVatExempt] = useState(false);
    const [showIndemnityPayment, setIndemnityPayment] = useState(false);
    const [isIndemnityPayment, setIsIndemnityPayment] = useState(false);
    const [isAgentPayee, setIsAgentPayee] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [lineItemVatData, setLineItemVatData] = useState([]);
    const [disablePmtType, setDisablePmtType] = useState(false);
    const [totalInclAmount, setTotalInclAmount] = useState(Number(0));
    const [paymentDataValidation, setPaymentDataValidated] = useState(false);
    const [paymentDocumentValidation, setDocumentValidation] = useState(false);
    const [sasriaPayeeData, setPayeeData] = useState([]);
    const [sasriaPayeeDetails, setPayeeDetails] = useState('');
    const [payeeType, setPayeeType] = useState('');
    const [paymentRefNo, setPaymentRefNo] = useState('');
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const {
        isOpen,
        onReject,
        onResolve,
        onAfterClose,
        claimVM,
        insuredPayee,
        agentPayee,
        // existingDocuments,
        // eslint-disable-next-line react/prop-types
        serviceRequestDocumentType,
        paymentData,
        editPayment,
        updateWizardData
    } = props;

    const retrivePayeeData = useCallback(() => {
        const payeeDataArray = [];
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const agent = _.get(policy, 'agentName_Ext');
        const insured = _.get(policy, 'insuredData_EXT');
        let insuredName = _.get(insured, 'insuredName');
        if (_.isUndefined(insuredName)) {
            insuredName = _.get(insured, 'companyName');
        }
        const insuredData = {
            code: 'insured',
            name: insuredName
        };
        const agentdData = {
            code: 'agent',
            name: agent
        };
        if (!_.isEmpty(insuredPayee)) {
            payeeDataArray.push(insuredData);
        }
        if (!_.isEmpty(agentPayee)) {
            payeeDataArray.push(agentdData);
        }
        setPayeeData(payeeDataArray);
        setDocumentValidation(false);
    }, [agentPayee, claimVM, insuredPayee]);


    const checkInvoiceValidationStatus = useCallback(() => {
        const otherValue = {
            code: 'other',
            name: 'Other'
        };
        const payee = _.get(paymentVM, 'payeeType_EXT');
        if (!_.isUndefined(payee) && payee.value === 'insured' && _.isUndefined(_.get(paymentVM.value, 'stppaymentType_EXT'))) {
            _.set(paymentVM, 'stppaymentType_EXT.value', otherValue.code);
        }
        const paymentType = _.get(paymentVM, 'stppaymentType_EXT.value');
        const lineItems = _.get(paymentVM, 'lineItemData_EXT.value', []);
        setPaymentDataValidated(!_.isUndefined(paymentType) && !_.isNil(paymentType.code) && !_.isNil(payee) && lineItems.length >= 1);
    }, [paymentVM]);

    useEffect(() => {
        setPaymentVM(
            viewModelService.create(
                paymentData,
                'cc',
                'edge.capabilities.claim.fnol.dto.PayeeDTO_EXT'
            )
        );
        if (editPayment !== true) {
            setLineItemVatData([]);
            const paymentRef = generateGuid();
            setPaymentRefNo(paymentRef);
        } else {
            const lineItems = _.get(paymentVM, 'lineItemData_EXT.value', []);
            if (!_.isEmpty(paymentData.lineItemData_EXT) && _.isEmpty(lineItems)) {
                _.set(paymentVM, 'lineItemData_EXT.value', paymentData.lineItemData_EXT);
            }
            setLineItemVatData(paymentData.lineItemData_EXT);
            setPaymentRefNo(paymentData.payeeRefNo_EXT);

            let totalExistingInclVat = 0.00;
            const existingLineItems = paymentData.lineItemData_EXT;
            if (!_.isEmpty(existingLineItems)) {
                existingLineItems.forEach((line) => {
                    totalExistingInclVat += parseFloat(line.vatInclAmount);
                });
            }
            setTotalInclAmount(totalExistingInclVat);
        }
        retrivePayeeData();
        setIsAgentPayee(false);
        _.set(paymentVM, 'stppaymentType_EXT.value', 'other'); // default value

        // for saving data when edit button is clicked

        if (editPayment === true) {
            setDisablePmtType(true);
            setPayeeDetails(paymentData.payeeType_EXT);
            _.set(paymentVM, 'payeeType_EXT', paymentData.payeeType_EXT);
            if (!_.isUndefined(paymentData.payeeType_EXT) && paymentData.payeeType_EXT === 'insured') {
                setIsAgentPayee(false);
                setIndemnityPayment(true);
                setIsIndemnityPayment(paymentData.stppaymentType_EXT === 'indemnityPayment');
            } else {
                setIndemnityPayment(false);
                setIsAgentPayee(true);
            }
            setPayeeType(paymentData.stppaymentType_EXT);
            // _.set(paymentVM, 'stppaymentType_EXT.value', value);
            _.set(paymentVM, 'stppaymentType_EXT.value.code', paymentData.stppaymentType_EXT);
            checkInvoiceValidationStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editPayment, paymentData, retrivePayeeData, viewModelService]);


    const getCurrencyValue = useCallback((rowData, index, property) => {
        // eslint-disable-next-line prefer-template
        return 'R' + rowData[property.id];
    }, []);

    const calculateEXclVatAmount = useCallback((value1) => {
        const policy = _.get(claimVM, 'policyData_EXT');
        const vatPercent = _.get(policy, 'vatPercent_EXT.value', 0);
        const upper = Number(value1) * Number(100);
        const exclValue = upper / (Number(vatPercent) + Number(100));
        const total = parseFloat(exclValue).toFixed(2);
        const inclusiveVatMount = {
            amount: total,
            currency: 'rand'
        };
        return inclusiveVatMount;
    }, [claimVM]);

    const calculateEXclVatAmountForExempt = useCallback((value1) => {
        const policy = _.get(claimVM, 'policyData_EXT');
        const vatPercent = _.get(policy, 'vatPercent_EXT.value', 0);
        const upper = Number(value1) * Number(100);
        const exclValue = upper / (Number(vatPercent) + Number(100));
        const total = parseFloat(Number(exclValue)).toFixed(2);
        const inclusiveVatMount = {
            amount: total,
            currency: 'rand'
        };
        return inclusiveVatMount;
    }, [claimVM]);

    const calculateVatAmount = useCallback((value1, value2) => {
        const vat = parseFloat(Number(value1) - Number(value2)).toFixed(2);

        const vatAmount = {
            amount: vat,
            currency: 'rand'
        };
        return vatAmount;
    }, []);

    const calculateVat = useCallback((value1, value2) => {
        const total = parseFloat(Number(value2) - Number(value1)).toFixed(2);
        const exclusiveVatMount = {
            amount: total,
            currency: 'rand'
        };
        return exclusiveVatMount;
    }, []);


    const clearLineItemData = useCallback(() => {
        _.set(paymentVM.value, 'description_EXT', undefined);
        _.set(paymentVM, 'description_EXT', undefined);
        _.set(paymentVM.value, 'vat_Excl_EXT', undefined);
        _.set(paymentVM.value, 'vat_EXT', undefined);
        _.set(paymentVM.value, 'vat_incl_EXT', undefined);
        _.set(paymentVM, 'vat_incl_EXT', undefined);
        _.set(paymentVM.value, 'vATExempt', undefined);
        setVatExempt(false);
    }, [paymentVM]);

    const addNewLineItem = useCallback(() => {
        const description = _.get(paymentVM.value, 'description_EXT');
        const vatExclAmount = _.get(paymentVM.value, 'vat_Excl_EXT.amount', 0);
        const vatAmount = _.get(paymentVM.value, 'vat_EXT.amount', 0);
        const vatInclAmount = _.get(paymentVM.value, 'vat_incl_EXT.amount', 0).toFixed(2);
        if (description && vatExclAmount > 0 && vatInclAmount > 0) {
            const lineItem = {
                description, vatExclAmount, vatAmount, vatInclAmount
            };
            let total = Number(totalInclAmount) + Number(vatInclAmount);
            total = +total.toFixed(2);
            setTotalInclAmount(total);
            lineItemVatData.push(lineItem);
            _.set(paymentVM.value, 'totalInclAmount_EXT', total);
            _.set(paymentVM, 'lineItemData_EXT.value', lineItemVatData);
            checkInvoiceValidationStatus();
            clearLineItemData();
            refreshData();
            if (lineItemVatData.length !== 0) {
                setDisablePmtType(true);
            }
        }
    }, [checkInvoiceValidationStatus, clearLineItemData, paymentVM, lineItemVatData, refreshData, totalInclAmount]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(paymentVM.value, path, value);
            if (path === 'vat_incl_EXT') {
                if (!_.isUndefined(value)) {
                    const referenceNum = _.get(paymentVM, 'referenceNumber');
                    _.set(paymentVM, 'description', referenceNum);
                    // eslint-disable-next-line max-len
                    // this is implemented for scenario when vat exempte checkbox is selected first and then amount is given
                    if (showVatExempt === true) {
                        const exclusiveVatMount = value;
                        _.set(paymentVM.value, 'vat_Excl_EXT', exclusiveVatMount);
                        const vatAmount = {
                            amount: Number(0),
                            currency: 'rand'
                        };
                        _.set(paymentVM.value, 'vat_EXT', vatAmount);
                        // eslint-disable-next-line max-len
                    } else {
                        const exclusiveVatMount = calculateEXclVatAmount(value.amount);
                        _.set(paymentVM.value, 'vat_Excl_EXT', exclusiveVatMount);
                        const vatAmount = calculateVatAmount(value.amount, exclusiveVatMount.amount);
                        _.set(paymentVM.value, 'vat_EXT', vatAmount);
                    }
                }
            } else if (path === 'vat_EXT') {
                const vatInclAmount = _.get(paymentVM.value, 'vat_Excl_EXT.amount', 0);
                if (!_.isUndefined(value)) {
                    const exclusiveAmt = calculateVat(value.amount, vatInclAmount);
                    _.set(paymentVM.value, 'vat_Excl_EXT', exclusiveAmt);
                }
            }
            checkInvoiceValidationStatus();
            refreshData();
        },
        [calculateEXclVatAmount, calculateVat, calculateVatAmount, checkInvoiceValidationStatus, paymentVM, refreshData, showVatExempt]
    );

    // eslint-disable-next-line no-unused-vars
    const handleVatExempt = useCallback((value, path) => {
        setVatExempt(!showVatExempt);
        const inclVatAmt = _.get(paymentVM.value, 'vat_incl_EXT');
        // eslint-disable-next-line max-len
        if (inclVatAmt) {
            if (value) {
                const exclusiveVatMount = inclVatAmt;
                // eslint-disable-next-line max-len
                const vat = {
                    amount: Number(0),
                    currency: 'rand'
                };
                _.set(paymentVM, 'vat_EXT.value', vat);
                _.set(paymentVM, 'vat_Excl_EXT.value', exclusiveVatMount);
            } else {
                // eslint-disable-next-line max-len
                const exclusiveVatMount = calculateEXclVatAmountForExempt(inclVatAmt.amount);
                // eslint-disable-next-line max-len
                const vatAmt = calculateVatAmount(inclVatAmt.amount, exclusiveVatMount.amount);
                _.set(paymentVM, 'vat_EXT.value', vatAmt);
                _.set(paymentVM, 'vat_Excl_EXT.value', exclusiveVatMount);
            }
        }
        refreshData();
        // eslint-disable-next-line max-len
    }, [calculateEXclVatAmountForExempt, calculateVatAmount, paymentVM, refreshData, showVatExempt]);


    const handleIndemnityCheck = useCallback((value) => {
        setIsIndemnityPayment(value);
        const indemnityValue = {
            code: 'indemnityPayment',
            name: 'Indemnity Payment'
        };
        const otherValue = {
            code: 'other',
            name: 'Other'
        };
        if (value === true) {
            _.set(paymentVM, 'stppaymentType_EXT.value', indemnityValue.code);
        } else {
            _.set(paymentVM, 'stppaymentType_EXT.value', otherValue.code);
        }
        checkInvoiceValidationStatus();
    }, [checkInvoiceValidationStatus, paymentVM]);

    const handlePayeeChange = useCallback((value) => {

        if (value === 'insured') {
            setIsAgentPayee(false);
            setIndemnityPayment(true);
        } else {
            setIndemnityPayment(false);
            setIsAgentPayee(true);
        }
        setPayeeDetails(value);
        _.set(paymentVM, 'payeeType_EXT', value);
        checkInvoiceValidationStatus();
    }, [paymentVM, checkInvoiceValidationStatus]);

    const handlePayeeType = useCallback((value) => {
        _.set(paymentVM, 'stppaymentType_EXT.value', value);
        setPayeeType(value);
        checkInvoiceValidationStatus();
    }, [paymentVM, checkInvoiceValidationStatus]);


    const handleAddPayment = useCallback(() => {
        // eslint-disable-next-line no-unused-expressions
        setPayeeDetails('');
        setIndemnityPayment(false);
        setIsIndemnityPayment(false);
        setDisablePmtType(false);
        setPayeeType('');
        addNewLineItem();
        setTotalInclAmount(Number(0));
        _.set(paymentVM, 'payeeRefNo_EXT.value', paymentRefNo);
        _.set(claimVM, 'paymentDTO', paymentVM);
        onResolve(paymentVM);
    }, [addNewLineItem, paymentVM, paymentRefNo, claimVM, onResolve]);

    const handleClose = useCallback(() => {
        setPayeeDetails('');
        setIndemnityPayment(false);
        setIsIndemnityPayment(false);
        setPayeeType('');
        setTotalInclAmount('');
        if (lineItemVatData.length !== 0) {
            setDisablePmtType(false);
        }
        onReject();
    }, [onReject, lineItemVatData]);

    const handleDelete = useCallback((e, item, index) => {
        const lineItems = _.get(paymentVM, 'lineItemData_EXT.value');
        let totalAmount = 0.00;
        if (!_.isEmpty(lineItems)) {
            lineItems.forEach((line) => {
                totalAmount += parseFloat(line.vatInclAmount);
            });
        }
        lineItems.splice((index), 1);
        const totalInclValue = parseFloat(totalAmount) - parseFloat(item.vatInclAmount);
        setTotalInclAmount(totalInclValue);
        setLineItemVatData(lineItems);
        _.set(paymentVM.value, 'totalInclAmount_EXT', totalInclValue);
        _.set(paymentVM, 'lineItemData_EXT.value', lineItems);
        checkInvoiceValidationStatus();
        refreshData();
        if (lineItemVatData.length === 0) {
            setDisablePmtType(false);
        }
    }, [paymentVM, refreshData, checkInvoiceValidationStatus]);

    const deleteLineItem = useCallback((item, index, property) => {
        return (
            <IconButton
                onClick={(e) => handleDelete(e, item, index)}
                className={styles.trashLink}
                icon="mi-delete"
            />
        );
    }, [handleDelete]);


    const handleInvoiceVMChange = useCallback((newModel) => {
        setPaymentVM(newModel);
        checkInvoiceValidationStatus();
        refreshData();
    }, [refreshData, checkInvoiceValidationStatus]);

    if (_.isEmpty(paymentVM)) {
        return null;
    }

    const getDocumentType = () => {
        switch (serviceRequestDocumentType) {
            case 'Fee_invoice':
                return 'Fee Invoice';
            case 'Reinstatement_Invoice':
                return 'Reinstatement Invoice';
            case 'Repair_Invoice':
                return 'Repair Invoice';
            case 'Salvage_Tender_Documents':
                return 'Salvage Tender Documents';
            default:
                return 'Fee Invoice';
        }
    };

    const overrides = {
        '@field': {
            showOptional: true
        },
        sasriaPayeeList: {
            availableValues: sasriaPayeeData,
            value: sasriaPayeeDetails
        },
        indemnityPayment: {
            value: isIndemnityPayment,
            onValueChange: handleIndemnityCheck,
            visible: showIndemnityPayment,
            disabled: disablePmtType
        },
        paymentType: {
            value: payeeType,
            visible: isAgentPayee,
            disabled: disablePmtType
        },
        lineVateExempt: {
            value: showVatExempt,
            onValueChange: handleVatExempt,
            visible: (isAgentPayee && payeeType === 'reimbursementVendor') || (!isAgentPayee && isIndemnityPayment === false)
        },
        lineItemsTable: {
            showSearch: false,
            data: lineItemVatData,
            visible: !_.isEmpty(lineItemVatData)
        },
        addLineButton: {
            onClick: addNewLineItem
        },
        totalInclAmount: {
            visible: !_.isEmpty(lineItemVatData),
            // eslint-disable-next-line prefer-template
            value: 'R' + totalInclAmount
        },
        serviceRequestDocumentType: {
            value: getDocumentType()
        },
        documentUploadForSTPBank: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData,
            docListForSpecificSteps: claimVM.value.bankDocumentCheckListSTP_EXT,
            payeeType: paymentVM.value.payeeType_EXT,
            payementTypeInsured: !_.isUndefined(paymentVM.stppaymentType_EXT.value) ? paymentVM.stppaymentType_EXT.value.code : undefined,
            payementTypeAgent: !_.isUndefined(paymentVM.stppaymentType_EXT.value) ? paymentVM.stppaymentType_EXT.value.code : undefined,
            documentValidation: setDocumentValidation,
            paymentRefNo: paymentRefNo
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCurrencyExclValue: getCurrencyValue,
            getCurrencyVatValue: getCurrencyValue,
            getCurrencyInclValue: getCurrencyValue,
            handlePayeeChange: handlePayeeChange,
            handlePayeeType: handlePayeeType,
            deleteLineItem: deleteLineItem
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            UploadComponentForBank: UploadComponentForBank
        }
    };

    return (
        <ModalNext isOpen={isOpen} onRequestClose={handleClose} onAfterClose={onAfterClose} shouldCloseOnOverlayClick={false}>
            <ModalHeader title={translator(messages.addInvoiceTitle)} />
            <ModalBody>
                <ViewModelForm
                    uiProps={metadata.componentContent.content}
                    model={paymentVM}
                    onModelChange={handleInvoiceVMChange}
                    componentMap={resolvers.resolveComponentMap}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    overrideProps={overrides}
                    onValueChange={writeValue}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    type="tertiary"
                    onClick={handleClose}
                >
                    {translator(messages.cancel)}
                </Button>
                <Button
                    onClick={handleAddPayment}
                    disabled={!(paymentDataValidation && paymentDocumentValidation)}
                >
                    {translator(messages.add)}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

AddPaymentPopup.propTypes = {
    isOpen: PropTypes.bool,
    // existingDocuments: PropTypes.arrayOf({}),
    insuredPayee: PropTypes.arrayOf({}),
    agentPayee: PropTypes.arrayOf({}),
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func,
    paymentData: PropTypes.shape({}),
    updateWizardData: PropTypes.func
};

AddPaymentPopup.defaultProps = {
    onAfterClose: _.noop,
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop,
    // existingDocuments: [],
    insuredPayee: [],
    agentPayee: [],
    paymentData: {},
    updateWizardData: _.noop
};

export default AddPaymentPopup;
